<template>
  <div class="wrapper">
    <div class="searchconditions">
      <el-form :model="ruleForm" ref="ruleForm" inline>
        <el-form-item label="标题" prop="title">
          <el-input
            v-model="ruleForm.data.title"
            placeholder="请输入标题"
          ></el-input>
        </el-form-item>
        <el-form-item prop="publishStatus">
          <el-select
            v-model="ruleForm.data.publishStatus"
            clearable
            placeholder="发布状态"
          >
            <el-option label="已发布" value="1"></el-option>
            <el-option label="未发布" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="cyan" @click="searchList"
            >查询</el-button
          >
          <el-button icon="el-icon-search" type="warning" @click="reset"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button
          class="add-button"
          type="primary"
          icon="el-icon-plus"
          size="mini"
          @click="handleAdd"
          >新增</el-button
        >
      </el-col>
    </el-row>
    <el-tabs v-model="tabname" @tab-click="clickTags">
      <el-tab-pane
        v-for="item in navlist"
        :key="item.type"
        :label="item.label"
        :name="item.type"
      >
        <el-table :data="newsList" style="width: 100%" v-loading="loading">
          <el-table-column prop="title" label="标题"> </el-table-column>
          <el-table-column prop="infomationType" label="导航图片">
            <template slot-scope="scope">
              <img
                :src="scope.row.fileUrl"
                style="width: 111px; height: 70px"
              />
            </template>
          </el-table-column>
          <el-table-column prop="contactPerson" label="发布状态">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.publishStatus"
                active-color="#13ce66"
                :active-value="'1'"
                :inactive-value="'0'"
                @change="statusChange1(scope.row)"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="首页显示状态">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                active-color="#13ce66"
                :active-value="'1'"
                :inactive-value="'0'"
                @change="statusChange2(scope.row)"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" prop="createTime" align="center">
            <template slot-scope="scope">
              {{ scope.row.createTime | timeformat }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-edit"
                @click="edit(scope.row)"
              >
                编辑</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev, pager, next, sizes, total, jumper"
          :page-sizes="[10, 15, 20]"
          :page-size="ruleForm.pageSize"
          :total="total"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </el-tab-pane>
    </el-tabs>

    <el-dialog
      title="新增新闻"
      :visible.sync="dialogAdd"
      :close-on-click-modal="false"
      @closed="close"
      z-index="100"
    >
      <div class="addform">
        <el-form :model="form" :rules="rules" ref="form" label-width="120px">
          <el-form-item label="分类" prop="infomationType">
            <el-select v-model="form.infomationType">
              <el-option label="公司动态" value="1"> </el-option>
              <el-option label="行业动态" value="2"> </el-option>
              <el-option label="相关政策" value="3"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="资讯标题" prop="title">
            <el-input v-model="form.title"></el-input>
          </el-form-item>
          <el-form-item label="简介" prop="intro">
            <el-input type="textarea" v-model="form.intro"></el-input>
          </el-form-item>

          <el-form-item label="导航图片" prop="fileUrl">
            <el-upload
              class="avatar-uploader"
              action=""
              :show-file-list="false"
              :http-request="uploadFile"
              :on-success="handleUpSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img v-if="form.fileUrl" :src="form.fileUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="首页显示状态" prop="status">
            <el-radio-group v-model="form.status">
              <el-radio label="1">显示</el-radio>
              <el-radio label="0">不显示</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="发布状态" prop="publishStatus">
            <el-radio-group v-model="form.publishStatus">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item prop="context" label="资讯内容">
            <div style="line-height: 22px">
              <vue-ueditor-wrap
                v-model="form.context"
                :config="myConfig"
                @beforeInit="addCustomDialog"
              ></vue-ueditor-wrap>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogAdd = false">取 消</el-button>
        <el-button type="primary" @click="saveAdd">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="上传图片"
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
      width="500px"
      :modal-append-to-body="false"
      z-index="5000"
    >
      <el-upload
        class="upload-demo"
        drag
        accept=".png, .jpg"
        action
        :on-success="uploadImageSuccess"
        :http-request="uploadArticleImage"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将文件拖到此处，或
          <em>点击上传</em>
        </div>
        <div class="el-upload__tip" slot="tip">
          只能上传jpg/png文件，且不超过5M
        </div>
      </el-upload>
    </el-dialog>
  </div>
</template>

<script>
import {
  getNewsList,
  uploadImage,
  saveNewsIntroduction,
  updateNewsIntroduction,
} from "@/common/api.js";
import VueUeditorWrap from "vue-ueditor-wrap";
export default {
  components: { VueUeditorWrap },
  props: {},
  data() {
    return {
      loading: false,
      tabname: "0",
      newsList: [],
      total: 0,
      rolesList: [],
      dialogAdd: false,
      dialogVisible: false,
      infomationType: "1",
      ruleForm: {
        pageSize: 10,
        pageNum: 1,
        data: {
          title: "",
          publishStatus: "",
          infomationType: "1",
        },
      },
      navlist: [
        {
          label: "公司动态",
          infomationType: "1",
        },
        {
          label: "行业动态",
          infomationType: "2",
        },
        {
          label: "相关政策",
          infomationType: "3",
        },
      ],
      form: {
        title: "",
        fileUrl: "",
        status: "1",
        publishStatus: "1",
        infomationType: "",
        intro: "",
        context: "",
      },

      rules: {
        title: [{ required: true, message: "请输入新闻标题", trigger: "blur" }],
        fileUrl: [
          { required: true, message: "请上传导航图片", trigger: "blur" },
        ],
        infomationType: [
          { required: true, message: "请选择分类", trigger: "blur" },
        ],
        context: [
          { required: true, message: "请填写资讯内容", trigger: "blur" },
        ],
        intro: [{ required: true, message: "请填写资讯简介", trigger: "blur" }],
      },
      myConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: true,
        // 初始容器高度
        initialFrameHeight: 300,
        // 初始容器宽度
        initialFrameWidth: "100%",
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: "/static/UEditor/",
      },
    };
  },
  watch: {},
  computed: {},
  methods: {
    addCustomDialog(editorId) {
      let that = this;
      window.UE.registerUI(
        "test-dialog",
        function (editor, uiName) {
          console.log(editor, uiName);
          // 参考http://ueditor.baidu.com/doc/#COMMAND.LIST
          var btn = new window.UE.ui.Button({
            name: "dialog-button",
            title: "上传图片",
            cssRules: `background-position: -381px 0`,
            onclick: function () {
              // 渲染dialog
              that.dialogVisible = true;
              editor.execCommand(uiName);
            },
          });
          return btn;
        },
        100 /* 指定添加到工具栏上的那个位置，默认时追加到最后 */,
        editorId /* 指定这个UI是哪个编辑器实例上的，默认是页面上所有的编辑器都会添加这个按钮 */
      );
    },
    // 新增新闻
    handleAdd() {
      this.dialogAdd = true;
    },
    //保存
    saveAdd() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          console.log(this.form);
          if (this.form.id) {
            updateNewsIntroduction(this.form).then((res) => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: "保存成功",
                });
                this.dialogAdd = false;
                this.getNewsList(this.ruleForm);
              } else {
                this.$message.error(res.msg);
              }
            });
          } else {
            saveNewsIntroduction(this.form).then((res) => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: "保存成功",
                });
                this.dialogAdd = false;
                this.getNewsList(this.ruleForm);
              } else {
                this.$message.error(res.msg);
              }
            });
          }
        }
      });
    },
    edit(row) {
      this.dialogAdd = true;
      this.$nextTick(() => {
        this.form = {
          id: row.id,
          title: row.title,
          fileUrl: row.fileUrl,
          status: row.status,
          publishStatus: row.publishStatus,
          infomationType: row.infomationType,
          intro: row.intro,
          context: row.context,
        };
      });
    },
    close() {
      this.$nextTick(() => {
        this.form = {
          id: "",
          title: "",
          fileUrl: "",
          status: "1",
          publishStatus: "1",
          infomationType: "",
          intro: "",
          context: "",
        };
        this.$refs["form"].resetFields();
      });
    },
    handleCurrentChange(cpage) {
      this.ruleForm.pageNum = cpage;
      this.getNewsList(this.ruleForm);
    },
    handleSizeChange(psize) {
      this.ruleForm.pageSize = psize;
      this.getNewsList(this.ruleForm);
    },
    clickTags(tab) {
      console.log(tab);
      this.ruleForm.data.infomationType = this.infomationType = String(
        Number(tab.index) + 1
      );
      this.getNewsList(this.ruleForm);
    },
    searchList() {
      this.getNewsList(this.ruleForm);
    },
    getNewsList(ruleForm) {
      this.loading = true;
      getNewsList(ruleForm).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          console.log("comanyInfoList :>> ", res);
          this.newsList = res.data.list;
          this.total = res.data.total;
        }
      });
    },
    // 搜索框重置
    reset() {
      this.$nextTick(() => {
        this.$refs["ruleForm"].resetFields();
        this.getNewsList(this.ruleForm);
      });
      this.ruleForm = {
        pageSize: 10,
        pageNum: 1,
        data: {
          title: "",
          publishStatus: "",
          infomationType: this.infomationType,
        },
      };
    },
    //导航图片上传
    uploadFile(file) {
      let formDatas = new FormData();
      formDatas.append("uploadFile", file.file);
      uploadImage(formDatas).then((res) => {
        if (res.code == 200) {
          file.onSuccess(res);
        }
      });
    },
    beforeAvatarUpload(file) {
      console.log(file);
      const isJPG =
        file.companyType === "image/jpeg" || "image/jpg" || "image/png";
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG或PNG 格式!");
      }
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5MB!");
      }
      return isJPG && isLt5M;
    },
    // 上传成功
    handleUpSuccess(res, file, fileList) {
      console.log(res);
      console.log(file);
      console.log(fileList);
      this.form.fileUrl = file.response.data;
    },
    // 富文本图片上传
    uploadImageSuccess(response, file, fileList) {
      if (response) {
        this.$message({
          message: "上传成功",
          type: "success",
        });
        console.log(file);
        let fileObj = {
          name: file.name,
          url: file.response,
        };
        this.insertUe(fileObj);
      } else {
        this.$message({
          message: "上传失败",
          type: "warning",
        });
      }
    },
    uploadArticleImage(file) {
      let formDatas = new FormData();
      formDatas.append("uploadFile", file.file);
      uploadImage(formDatas).then((res) => {
        if (res.code == 200) {
          file.onSuccess(res.data);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    insertUe(file) {
      console.log(file);
      let editor = document.querySelector(".edui-default").getAttribute("id");
      console.log(editor);
      window.UE.getEditor(editor).execCommand("insertimage", {
        src: file.url,
        width: "100",
        height: "100",
      });
      this.dialogVisible = false;
    },
    // 修改发布状态
    statusChange1(row) {
      const h = this.$createElement;
      let text = "";
      if (row.publishStatus == 1) {
        text = "发布";
      } else if (row.publishStatus == 0) {
        text = "取消发布";
      }
      this.$msgbox({
        title: "提示",
        message: h("p", null, [
          h("h3", null, '确定 "' + text + '" 此新闻资讯吗?', "警告"),
        ]),
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            done();
            var params = {
              id: row.id,
              status: row.status,
            };
            updateNewsIntroduction(row).then((res) => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: "操作成功",
                });
              } else {
                this.$message.error(res.msg);
                if (row.publishStatus == "1") {
                  row.publishStatus = "0";
                } else if (row.publishStatus == "0") {
                  row.publishStatus = "1";
                }
              }
            });
          } else {
            done();
            if (row.publishStatus == "1") {
              row.publishStatus = "0";
            } else if (row.publishStatus == "0") {
              row.publishStatus = "1";
            }
          }
        },
      })
        .then((action) => {
          console.log("确定");
        })
        .catch(() => {
          console.log("取消");
        });
    },
    // 修改首页显示状态
    statusChange2(row) {
      const h = this.$createElement;
      let text = "";
      if (row.status == 1) {
        text = "首页显示";
      } else if (row.status == 0) {
        text = "取消首页显示";
      }
      this.$msgbox({
        title: "提示",
        message: h("p", null, [
          h("h3", null, '确定 "' + text + '" 此新闻资讯吗?', "警告"),
        ]),
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            done();
            updateNewsIntroduction(row).then((res) => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: "操作成功",
                });
              } else {
                this.$message.error(res.msg);
                if (row.status == "1") {
                  row.status = "0";
                } else if (row.status == "0") {
                  row.status = "1";
                }
              }
            });
          } else {
            done();
            if (row.status == "1") {
              row.status = "0";
            } else if (row.status == "0") {
              row.status = "1";
            }
          }
        },
      })
        .then((action) => {
          console.log("确定");
        })
        .catch(() => {
          console.log("取消");
        });
    },
  },
  created() {},
  mounted() {
    this.getNewsList(this.ruleForm);
  },
};
</script>
<style lang="less" scoped>
.wrapper {
  .searchconditions {
    width: calc(100% - 30px);
    background: #fff;
    border-radius: 6px;
    margin-top: 10px;
    padding: 15px 12px;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
    .el-form {
      .el-form-item {
        display: inline-block;
        margin-right: 10px;
        vertical-align: top;
        margin: 5px 15px 5px 0px;
        /deep/.el-button {
          padding: 8px 15px;
          font-size: 12px;
          border-radius: 3px;
        }
      }
    }
  }
  .add-button {
    margin: 20px 0 10px 10px;
  }
  // /deep/.el-input__inner,
  // /deep/.el-form-item__content {
  // height: 34px;
  //   line-height: 34px;
  // }
  /deep/.el-input__icon,
  /deep/.el-form-item__label {
    line-height: 34px;
  }

  .el-tabs {
    background: #fff;
  }
  /deep/.el-tabs__header {
    margin-top: 10px;
  }
  .content {
    background: #fff;
    padding: 20px;
    div {
      margin-bottom: 30px;
      .span1 {
        margin-right: 80px;
      }
    }
    input {
      width: 18%;
      border: 1px solid #eee;
      height: 40px;
    }
  }
  .btnbox {
    padding-left: 20px;
    margin: 20px 0;
  }
  .check-submit {
    padding: 20px 0 0 100px;
  }
  .avtive {
    background-color: #62a8ea;
    color: #fff;
  }
  .company-form {
    padding: 20px;
  }
  a.toview {
    color: #62a8ea;
  }
  /deep/.el-tabs__nav-wrap {
    padding-left: 20px;
  }
  /deep/.el-button {
    padding: 8px 15px;
    font-size: 12px;
    border-radius: 3px;
  }
  .avatar-uploader {
    /deep/.el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 267px;
      height: 168px;
      line-height: 168px;
      text-align: center;
    }
    .avatar {
      width: 267px;
      height: 168px;
      display: block;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/system/newsList.vue